module.exports = __webpack_public_path__ + "assets/df0d5927c11be933d9cff4d4116ef551.icon_calendar_gray.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/icon_calendar_gray.svg
 ** module id = 832
 ** module chunks = 0
 **/